import React from 'react'
import { Edit } from 'react-admin'
import TournamentForm from './TournamentForm'
import Toolbar from '../../components/FormToolbar'
import { configureTornamentBeforeUpdate } from '../utils/configureTournamentBeforeRecord'
import { uploadFile } from '../utils/configureDataBeforeRecord'

const EditTournament = (props) => {
  const transform = async (data) => {
    if (data.poster?.rawFile instanceof File) {
      data.poster = await uploadFile(data.poster)
    } else {
      delete data.poster
    }

    configureTornamentBeforeUpdate(data)
    const { facsimile, tournamentLevel, ...rest } = data
    return rest
  }

  return (
    <Edit
      {...props}
      transform={transform}
      toolbar={<Toolbar />}
      title='Редактирование турнира'
      undoable={false}
    >
      <TournamentForm {...props} isEdit={true} />
    </Edit>
  )
}

export default EditTournament
